/**
 * Idle scheduling for non-critical startup work.
 */
export function scheduleStartupIdle(task, timeoutMs = 3000) {
  let cancelled = false;
  let idleId = null;
  let timeoutId = null;

  const run = () => {
    if (cancelled) return;
    void task();
  };

  if (typeof requestIdleCallback === 'function') {
    idleId = requestIdleCallback(run, { timeout: timeoutMs });
  } else {
    timeoutId = setTimeout(run, 0);
  }

  return () => {
    cancelled = true;
    if (idleId != null && typeof cancelIdleCallback === 'function') {
      cancelIdleCallback(idleId);
    }
    if (timeoutId != null) clearTimeout(timeoutId);
  };
}

